import React from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import serviceHero from "../Assets/service3.jpg";
import serviceImage1 from "../Assets/service3.1.jpg";
import serviceImage2 from "../Assets/service3.2.avif";
import serviceImage3 from "../Assets/service3.3.jpg";

const Innovative = () => {
  return (
    <div>
      <Fixed />
      <div className="bg-gray-50 text-gray-900 pt-20">
        {/* Hero Section */}
        <section
          className="relative w-full h-screen flex items-center justify-center bg-cover bg-center text-center text-white"
          style={{ backgroundImage: `url(${serviceHero})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 px-6">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-5xl font-extrabold text-white"
            >
              Innovative Intelligence Solutions
            </motion.h1>
            <p className="mt-4 text-lg max-w-3xl mx-auto">
              Empowering businesses with cutting-edge AI, IoT, and automation solutions for a smarter future.
            </p>
          </div>
        </section>

        {/* Innovative & Intelligent Solutions Section */}
<section className="container mx-auto px-6 py-16">
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    className="bg-gradient-to-br from-blue-50 to-white shadow-lg rounded-lg p-10"
  >
    <h2 className="text-4xl font-bold text-blue-700 text-center">Innovative & Intelligent Solutions</h2>
    <p className="mt-4 text-lg text-gray-700 text-center">
      Empowering businesses with AI-driven automation, smart analytics, and cutting-edge technologies to drive efficiency and innovation.
    </p>

    <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
      {[
        {
          title: "AI-Powered Automation",
          description: "Leverage artificial intelligence to streamline processes, reduce costs, and enhance decision-making in real-time.",
        },
        {
          title: "Smart Data Analytics",
          description: "Utilize big data and machine learning to gain actionable insights, predict trends, and improve business strategies.",
        },
        {
          title: "IoT & Smart Devices",
          description: "Connect and control smart devices remotely for efficient monitoring, predictive maintenance, and seamless automation.",
        },
        {
          title: "Cybersecurity & Compliance",
          description: "Implement robust security solutions to protect sensitive data and ensure compliance with industry standards.",
        },
        {
          title: "Cloud & Edge Computing",
          description: "Optimize your infrastructure with scalable cloud solutions and real-time edge computing for enhanced performance.",
        },
        {
          title: "Intelligent Robotics",
          description: "Enhance industrial and commercial operations with AI-driven robotics for automation and precision tasks.",
        }
      ].map((service, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: index * 0.2 }}
          className="bg-white p-6 rounded-lg shadow-md border-b-4 border-blue-500"
        >
          <h3 className="text-2xl font-semibold text-blue-600">{service.title}</h3>
          <p className="mt-2 text-gray-700">{service.description}</p>
        </motion.div>
      ))}
    </div>
  </motion.div>
</section>

        {/* Our Core Services */}
        <section className="bg-blue-50 py-16">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold text-blue-800">Our Expertise</h2>
            <div className="grid md:grid-cols-3 gap-8 mt-10">
              {[
                { title: "AI & Machine Learning", image: serviceImage2 },
                { title: "IoT & Smart Automation", image: serviceImage3 },
                { title: "Cloud Computing & Big Data", image: serviceImage1 },
              ].map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="bg-white p-6 rounded-lg shadow-md border-b-4 border-blue-600"
                >
                  <img src={service.image} alt={service.title} className="rounded-lg mb-4" />
                  <h3 className="text-2xl font-semibold text-blue-600">{service.title}</h3>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="container mx-auto px-6 py-16 text-center">
          <h2 className="text-4xl font-bold text-blue-800">How It Works</h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { title: "Consultation & Planning", description: "Understanding your needs and designing a tailored solution." },
              { title: "Development & Integration", description: "Building AI-driven and IoT-enabled solutions for efficiency." },
              { title: "Deployment & Optimization", description: "Ensuring seamless integration with continuous improvements." }
            ].map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="bg-white p-6 rounded-lg shadow-md border-t-4 border-blue-500"
              >
                <h3 className="text-2xl font-semibold text-blue-600">{step.title}</h3>
                <p className="mt-2 text-gray-700">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 text-center bg-white border-t border-gray-300">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-blue-800">Get Started with Smart Solutions</h2>
            <p className="mt-4 text-lg text-gray-700">Empower your business with AI, IoT, and intelligent automation.</p>
          </div>
        </section>
      </div>
      <Footer1 />
    </div>
  );
};

export default Innovative;
